import App from './App.vue';
import { fetchData } from './actions/identity';
import setting from './config';
import urlQueryParts from './helpers/urlQueryParts';
import router from './router';
import store from './store/store';
import { types } from './types';
import VueQrcode from '@xkeshi/vue-qrcode';
import Vue from 'vue';
import VueCookie from 'vue-cookie';
import VModal from 'vue-js-modal';
import VueMoment from 'vue-moment';
import VueYandexMetrika from 'vue-yandex-metrika';
import { VueReCaptcha } from 'vue-recaptcha-v3';
import VueMobileDetection from 'vue-mobile-detection';
import 'regenerator-runtime/runtime';
import vkBridge from '@vkontakte/vk-bridge';
import initDebugOverlay from '@/debug/debugOverlay';

Vue.component(VueQrcode.name, VueQrcode);

const moment = require('moment');

const searchParams = new URLSearchParams(window.location.search);
// Флаг обозначения мобильной версии VK mini app
const isVkMobileFromQuery = searchParams.get('vkmobile') === 'true';
// Флаг обозначения десктопной версии VK mini app
const isVkWidget = searchParams.get('vk') === 'true';

store.commit('SET_VK_WIDGET', isVkWidget);
store.commit('SET_VK_MOBILE_WIDGET', isVkMobileFromQuery);

Vue.config.productionTip = false;
Vue.use(VModal);
Vue.use(VueMobileDetection);
Vue.use(VueCookie);
Vue.use(VueMoment, {
  moment,
});
Vue.use(VueYandexMetrika, {
  id: 52995523,
  router: router,
  env: 'production',
});

if (!isVkMobileFromQuery) {
  Vue.use(VueReCaptcha, {
    siteKey: '6Le3UvgmAAAAALhGMZhJi38AzGQK2wnmQWgP_5dP',
    loaderOptions: {
      autoHideBadge: true,
    },
  });
} else {
  console.info('vkmobile is true');
}

initDebugOverlay({
  flag: 'development',
  bridge: vkBridge,
  console: window.console,
});

if (setting.yandexMetrikaId && window.location.hostname !== 'localhost') {
  Vue.use(VueYandexMetrika, {
    id: setting.yandexMetrikaId,
    router: router,
    env: process.env.NODE_ENV,
  });
}

export const eventBus = new Vue();

new Vue({
  router,
  store,
  render: (h) => h(App),
  async created() {
    let { orderId } = this.$route.query;

    if (orderId) {
      this.$router.push(`/success${urlQueryParts(this.$route.query)}`);
    }

    const idToken = this.$cookie.get('i');
    const authToken = this.$cookie.get('i');

    //debugger;
    if (this.$route.params.session && this.$route.params.theatreId) {
      this.$store
        .dispatch('loadApp', {
          session: this.$route.params.session,
          theatreId: this.$route.params.theatreId,
          filmId: this.$route.query.filmId,
          idToken,
          authToken,
        })
        .then(() => {
          // TODO в await контексте не сработает
          if (idToken && this.$route.params.theatreId) {
            fetchData(idToken).then((user) => {
              //debugger;
              this.$store.commit(types.SET_USER_DATA, user);
              let cardNumber =
                user && user.profile && user.publicId
                  ? user.publicId
                  : 'карта отсутствует';

              if (cardNumber !== 'карта отсутствует') {
                this.$store.dispatch('fetchUserBalance', {
                  card: cardNumber,
                  apiKey: this.$route.params.theatreId,
                });
              }
            });
          }
        });

      // const user = {
      //   id: 'cjtfqm8fxosgk0735gu55blv1',
      //   username: 'devadmin',
      //   email: 'example@mediaten.ru',
      //   publicId: 714881722,
      //   status: 'ACTIVE',
      //   createdAt: '2019-03-19T12:11:45.597Z',
      //   updatedAt: '2019-12-26T08:19:50.500Z',
      //   role: ['ADMIN'],
      //   permissions: ['admin', 'crm'],
      //   crmSystems: [],
      //   profile: {
      //     id: 'cjtfqm8fzosgl073502d845lf',
      //     name: 'Administrator',
      //     image: 'https://cdn.pzpreprod.66bit.ru/img/76fmcohl5cy2f3bi.png',
      //     card: 714881722,
      //     birthday: '2005-09-22T00:00:00.000Z',
      //     gender: 'MALE',
      //     phone: '+7 111 111-11-11',
      //     mobilePhone: '+79028722480',
      //   },
      //   employeeInfo: {
      //     id: 'cjtfqm8g1osgn0735d29crvr9',
      //     phones: [],
      //     theatre: null,
      //   },
      // };
      //
      // this.$store.commit(types.SET_USER_DATA, user);
    }

    this.$moment.locale('Ru');
  },
}).$mount('#app');
